import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import NavLabel from '../NavLabel';

class NavDrop extends Component {
  constructor(props) {
    super(props);

    this.handleDropClick = this.handleDropClick.bind(this);
    this.state = {
      dropActive: this.props.dropActive ? this.props.dropActive : false
    }
  }

  componentWillMount() {
    this.setState({
      dropActive: false
    })
  }

  componentWillReceiveProps(nextProps) {
    let { dropActive } = nextProps;
    this.setState({ dropActive });
  }

  handleDropClick() {
    this.setState({
      dropActive: !this.state.dropActive
    })
  }

  render() {
    const { dropActive } = this.state;
    let dropClass = 'sidebar__dropdown--wrap ';
    if (dropActive)
      dropClass = dropClass + 'sidebar__dropdown--active';
    return (
      <NavLabel
        name={this.props.name}
        handleClick={this.handleDropClick}
        showArrow={true}
        isActive={dropActive}
        selectedText={this.props.selectedText}>
        {
          this.props.activeName &&
          <p className="sidebar__selected">{this.props.activeName}</p>
        }
        <div className={dropClass}>
          <div className="sidebar__search--wrap">
            <input
              onChange={this.props.handleSearchChange}
              className="sidebar__search"
              placeholder="Search"
              value={this.props.searchValue} />
            <img className="sidebar__search--icon" src="/images/searchIcon.svg"/>
          </div>
          {this.props.children}
        </div>
      </NavLabel>
    )
  }
}

NavDrop.propTypes = {
  name: PropTypes.string.isRequired,
  selectedText: PropTypes.string,
  handleSearchChange: PropTypes.func.isRequired,
  searchValue: PropTypes.string.isRequired

};

export default NavDrop;



/** WEBPACK FOOTER **
 ** ./src/components/NavDrop/index.js
 **/